import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState  from 'vuex-persistedstate'

Vue.use(Vuex)//使用vuex


//Vuex Store 实例的根状态对象，用于定义共享的状态变量，就像Vue实例中的data
const state = {
	userInfo: {},//用户信息
	token: '',//token
	//网络畅通
	network: true,
  // 动态缓存需要的组件
  keepAlive: [] // 这里添加的是vue文件的name
}
//获取状态信息，读取器，外部程序通过它获取state里变量的具体值，或者在取值前做一些计算
const getters = {
	userInfo: state => state.userInfo,
	token: state => state.token,
  keepAlive: state => state.keepAlive
}
//更改state状态信息，唯一能修改state里面的变量的方法就是提交mutations
const mutations = {
	//设置用户信息
	setUserInfo(state, userInfo) {
		if(userInfo) {//如果存在
			state.userInfo = userInfo
		}else{
			state.userInfo = {}
		}
	},
	//设置token
	setToken (state, token) {
		if(token) {//如果存在
			state.token = token
		}else{
			state.token = ''
		}
	},
	changeNetwork(state,str){
		if(str){
			state.network = false
		}else{
			state.network = true
		}
	},
  setKeepAlive: (state, keepAlive) => {
    console.log(keepAlive)
    state.keepAlive = keepAlive;
  }
}
//动作，向store发出调用通知，执行本地或远端的某一个操作，可以理解为store里面的methods
const actions = {
	//设置个人信息
	setUserInfo: ( {commit} , userInfo) => {
		commit('setUserInfo', userInfo)
	},
	//设置token
	setToken: ( {commit} , token) => {
		commit('setToken', token)
	},
	//退出登录清空状态
	clearCurrentState: ( {commit} ) => {
		commit('setUserInfo', null)//清空用户信息
		commit('setToken', null)//清空token
	},
	changeNetwork({commit},str){
		commit("changeNetwork",str)
	}
}
const strict = {
	//设置Vuex的运行模式，true为调试模式，false为生产模式
}

const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
  plugins: [createPersistedState()]
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js